import React from 'react'
import { Select, Input, Form, Button, Divider, message, Tabs, Anchor, Spin, Pagination, Tooltip, DatePicker, Steps, Popconfirm, Modal } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import {getParmUrl, outputMoney, getCookie} from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './medical-equipmentn-onhaitao.module.less'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
class BasicInformation extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      medicalCareOnHtaoData: null,
      propertyData: [],
      categoryArr: [],
      brandArr: [],
      CommonNameData: [],
      skuVal: '',
      skuType: '',
      skuVisible: false
    }
  }

  componentDidMount () {
    let {medicalCareOnHtaoData} = this.state
    medicalCareOnHtaoData = JSON.parse(sessionStorage.getItem('medicalCareOnHtaoData'))
    this.setState({
      medicalCareOnHtaoData
    }, () => {
      if (!getParmUrl('id')) {
        this.getQueryProperty()
      }
    })
    this.getQueryCategory()
    this.getQueryBrand()
    this.getCommonNameData()
  }

  componentWillReceiveProps (nextprops) {
    let {medicalCareOnHtaoData} = this.state
    medicalCareOnHtaoData = JSON.parse(sessionStorage.getItem('medicalCareOnHtaoData'))
    this.setState({
      medicalCareOnHtaoData
    }, () => {
      if (!getParmUrl('id')) {
        this.getQueryProperty()
      }
    })
  }

  // 获取通用名称的数据
  getCommonNameData=async () => {
    let {CommonNameData} = this.state
    try {
      let _param = {'appkey': 'sigo', 'appsecret': 'sigo', 'accesstoken': '075DFE1EE73515BEC6180B8200F36265', 'action': 'getcommonitemname'}
      let res = await ajaxApi({
        url: common.erpapiUrl+'scm/item/getcommonitemname',
        params: _param,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      })
      if (res.status === 200) {
        if (res.data.length !== 0) {
          this.setState({
            CommonNameData: res.data
          })
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 查询品牌
  getQueryBrand = async () => {
    let {brandArr} = this.state
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-brand',
        params: {}
      })
      if (res.status === 200 && res.data) {
        this.setState({
          brandArr: res.data.data
        })
      } else {
        this.setState({
          brandArr: []
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 查询类别
  getQueryCategory = async () => {
    let { categoryArr } = this.state
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-category',
        params: {}
      })
      if (res.status === 200 && res.data) {
        this.setState({
          categoryArr: res.data.data
        })
      } else {
        this.setState({
          categoryArr: []
        })
      }
    } catch (e) {
      console.log(e)
    }
  };

  // 获取sku和属性
  getQueryProperty=async () => {
    let {medicalCareOnHtaoData} = this.state
    try {
      let _params = {
        category_id: medicalCareOnHtaoData.item_info.category_id
      }
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-property',
        // url: 'http://192.168.10.220:8120/item/query-property',
        params: _params
      })
      if (res.status === 200 && res.data) {
        let _data = res.data.data
        if (_data.length !== 0) {
          if (medicalCareOnHtaoData.extend_propertys.length === 0 && medicalCareOnHtaoData.sku_propertys.length === 0) {
            _lodash.forEach(_data, (item, index) => {
              if (item.property_type === 'Extend') {
                medicalCareOnHtaoData.extend_propertys.push({
                  'property_id': item.property_id,
                  'property_name': item.property_name,
                  'sku_value': item.property_value ? item.property_value : [''],
                  'property_type': item.property_type,
                  'is_required': item.is_required
                })
              } else {
                medicalCareOnHtaoData.sku_propertys.push({
                  'property_id': item.property_id,
                  'property_name': item.property_name,
                  'sku_value': item.property_value ? item.property_value : [],
                  'property_type': item.property_type,
                  'is_required': item.is_required
                })
              }
            })
          }
        }

        this.setState({
          propertyData: res.data.data,
          medicalCareOnHtaoData
        }, () => {
          sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 获取输入框的值
  handleChangeInput=(e, name) => {
    let {medicalCareOnHtaoData} = this.state
    medicalCareOnHtaoData.item_info[name] = e.target.value
    this.setState({
      medicalCareOnHtaoData
    }, () => {
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }

  // 获取下拉框的值
  handelChangeSource=(e, name) => {
    let {medicalCareOnHtaoData, brandArr} = this.state
    medicalCareOnHtaoData.item_info[name] = e
    if (name === 'brand_id') {
      _lodash.forEach(brandArr, (item, index) => {
        if (e === item.id) {
          medicalCareOnHtaoData.item_info.brand_name = item.name
        }
      })
    }
    this.setState({
      medicalCareOnHtaoData
    }, () => {
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }

  // 获取Extend输入框的值
  handleChangeInputExtend=(e, index) => {
    let {medicalCareOnHtaoData} = this.state
    medicalCareOnHtaoData.extend_propertys[index].extend_value = e.target.value
    this.setState({
      medicalCareOnHtaoData
    }, () => {
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }

  // // 获取Sku输入框的值
  // handleChangeInputSku=(e, index, index2) => {
  //   let {medicalCareOnHtaoData} = this.state
  //   medicalCareOnHtaoData.sku_propertys[index].sku_value[index2] = e.target.value
  //   this.setState({
  //     medicalCareOnHtaoData
  //   }, () => {
  //     sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
  //   })
  // }

  // 获取Extend下拉框的值
  handleChangeSelectExtend=(e, index) => {
    let { medicalCareOnHtaoData } = this.state
    medicalCareOnHtaoData.extend_propertys[index].extend_value = e
    this.setState(
      {
        medicalCareOnHtaoData
      },
      () => {
        sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
      }
    )
  }

// 获取Sku输入框的值
handleChangeInputSku=(e, index, name) => {
  let {medicalCareOnHtaoData} = this.state
  // medicalCareOnHtaoData.sku_propertys[index].sku_value[index2] = e.target.value
  this.setState({
    // medicalCareOnHtaoData
    skuVal: e.target.value,
    skuType: name
  }, () => {
    // sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
  })
}

  // sku添加
  handleSkuAdd=(e, index, name) => {
    let { medicalCareOnHtaoData, skuType, skuVal } = this.state
    // medicalCareOnHtaoData.sku_propertys[index].sku_value.push('')
    if (name === skuType) {
      if (skuVal === '') {
        message.warning('请填写要添加的SKU属性值')
      } else {
        medicalCareOnHtaoData.sku_propertys[index].sku_value.push(skuVal)
        medicalCareOnHtaoData.sku_propertys[index].sku_value = _lodash.uniqWith(medicalCareOnHtaoData.sku_propertys[index].sku_value, _lodash.isEqual)
        skuVal = ''
      }
    } else {
      message.warning('请填写要添加的SKU属性值')
    }
    this.setState({
      medicalCareOnHtaoData,
      skuVal
    }, () => {
      console.log(this.state.medicalCareOnHtaoData)
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }

  // sku光度选择添加
  handleSkuSelectAdd=(e, index, name) => {
    let { medicalCareOnHtaoData, skuType, skuVal } = this.state
    this.setState({
      skuVisible: true,
      skuIndex: index
    })
  }

  // sku光度快捷添加
  handleSkuQuickAdd=(e, type) => {
    let { medicalCareOnHtaoData, skuIndex } = this.state
    let _skuArrMin = ['0.00', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', '-2.25', '-2.50', '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', '-4.25', '-4.50', '-4.75', '-5.00', '-5.25', '-5.50', '-5.75', '-6.00', '-6.50', '-7.00', '-7.50', '-8.00']
    let _skuArrMax = ['0.00', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', '-2.25', '-2.50', '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', '-4.25', '-4.50', '-4.75', '-5.00', '-5.25', '-5.50', '-5.75', '-6.00', '-6.50', '-7.00', '-7.50', '-8.00', '-8.50', '-9.00', '-9.50', '-10.00', '-10.50', '-11.00', '-11.50', '-12.00']
    if (type === 'Y-1.00-0.25-6.00-0.50-8.00') {
      _skuArrMin.map(item => {
        medicalCareOnHtaoData.sku_propertys[skuIndex].sku_value.push(item)
      })
    } else {
      _skuArrMax.map(item => {
        medicalCareOnHtaoData.sku_propertys[skuIndex].sku_value.push(item)
      })
    }
    medicalCareOnHtaoData.sku_propertys[skuIndex].sku_value = _lodash.uniqWith(medicalCareOnHtaoData.sku_propertys[skuIndex].sku_value, _lodash.isEqual)
    this.setState({
      medicalCareOnHtaoData,
      skuVisible: false
    }, () => {
      console.log(this.state.medicalCareOnHtaoData)
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }

  // sku删除
  handledelete=(e, index, index2) => {
    let { medicalCareOnHtaoData } = this.state
    medicalCareOnHtaoData.sku_propertys[index].sku_value.splice(index2, 1)
    this.setState({
      medicalCareOnHtaoData
    }, () => {
      sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(this.state.medicalCareOnHtaoData))
    })
  }

  // 弹框隐藏
  handleCancel=() => {
    this.setState({
      skuVisible: false
    })
  }

  // 下一步
  handleNext=() => {
    let {medicalCareOnHtaoData} = this.state
    sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(medicalCareOnHtaoData))
    this.props.getCurrent(1)
  }

  //  上一步
  handleBack =() => {
    let {medicalCareOnHtaoData} = this.state
    sessionStorage.setItem('medicalCareOnHtaoData', JSON.stringify(medicalCareOnHtaoData))
    sessionStorage.setItem('current', 0)
  }

  render () {
    let {propertyData, medicalCareOnHtaoData} = this.state
    return (
      <div>
        <div style={{display: 'flex', border: '1px solid #d9d9d9'}}>
          {/* <div style={{width: '15%', borderRight: '1px solid #d9d9d9'}}>
            <div className={styles.informationtitle} style={{marginTop: '8%'}}>基础信息</div>
            <div className={styles.informationtitle} style={{marginTop: '130%'}}>扩展信息</div>
            <div className={styles.informationtitle}>SKU</div>
    </div> */}
          <div style={{width: '100%'}}>

            <div style={{paddingLeft: '17%', marginTop: '24px', fontSize: '16px'}}><span className={styles.titles}>基础信息</span></div>
            <div style={{display: 'flex', flexWrap: 'wrap', width: '100%', paddingLeft: '13%'}}>
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>商品编码：</span>
                <Input onKeyDown={this.onKeyup} disabled value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.item_code : ''} placeholder='自动生成，不输入' name='item_code' onChange={(e) => this.handleChangeInput(e, 'item_code')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>商品简称：</span>
                <Input onKeyDown={this.onKeyup} disabled value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.short_name : ''} placeholder='自动生成，不输入' name='short_name' onChange={(e) => this.handleChangeInput(e, 'short_name')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>商品名称：</span>
                <Input onKeyDown={this.onKeyup} value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.item_name : ''} placeholder='请输入' name='item_name' onChange={(e) => this.handleChangeInput(e, 'item_name')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>商品品牌：</span>
                <Select
                  showSearch
                  // mode="multiple"
                  onKeyDown={this.onKeyup}
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.brand_id : ''}
                  onChange={(e) => this.handelChangeSource(e, 'brand_id')}
                >
                  <Option key={0} name='brand_id' value=''>请选择</Option>
                  {this.state.brandArr || this.state.brandArr.length === 0 ? this.state.brandArr.map((item, index) => (
                    <Option key={index + 1} name='brand_id' value={item.id}>{item.name}</Option>
                  )) : null}
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>商品类别：</span>
                <Select
                  showSearch
                  // mode="multiple"
                  onKeyDown={this.onKeyup}
                  disabled
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.category_id : ''}
                  onChange={(e) => this.handelChangeSource(e, 'category_id')}
                >
                  <Option key={0} name='category_id' value=''>请选择</Option>
                  {(this.state.categoryArr || this.state.categoryArr.length === 0) ? this.state.categoryArr.map((item, index) => (
                    <Option key={index + 1} name='category_id' value={item.id}>{item.name}</Option>
                  )) : null}
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>通用名称：</span>
                <Select
                  showSearch
                  // mode="multiple"
                  onKeyDown={this.onKeyup}
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.common_name : ''}
                  onChange={(e) => this.handelChangeSource(e, 'common_name')}
                >
                  <Option key={0} name='common_name' value=''>请选择</Option>
                  {this.state.CommonNameData || this.state.CommonNameData.length === 0 ? this.state.CommonNameData.map((item, index) => (
                    <Option key={index + 1} name='common_name' value={item.value}>{item.name}</Option>
                  )) : null}
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>商品描述：</span>
                <Input onKeyDown={this.onKeyup} placeholder='请输入' name='description' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.description : ''} onChange={(e) => this.handleChangeInput(e, 'description')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>规格：</span>
                <Input onKeyDown={this.onKeyup} placeholder='请输入' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.spec : ''} name='spec' onChange={(e) => this.handleChangeInput(e, 'spec')} style={{ width: 244, marginRight: '0px' }} /><span>片状/ml</span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>计价单位：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.price_unit : ''}
                  onChange={(e) => this.handelChangeSource(e, 'price_unit')}
                >
                  <Option key={0} name='price_unit' value=''>请选择</Option>
                  <Option key={1} name='price_unit' value='盒'>盒</Option>
                  <Option key={2} name='price_unit' value='瓶'>瓶</Option>
                  <Option key={3} name='price_unit' value='副'>副</Option>
                  <Option key={4} name='price_unit' value='片'>片</Option>
                  <Option key={5} name='price_unit' value='只'>只</Option>
                  <Option key={6} name='price_unit' value='支'>支</Option>
                  <Option key={7} name='price_unit' value='个'>个</Option>
                  <Option key={8} name='price_unit' value='套'>套</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>是否散光片：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.is_customed : ''}
                  onChange={(e) => this.handelChangeSource(e, 'is_customed')}
                >
                  <Option key={0} name='is_customed' value={1}>是</Option>
                  <Option key={1} name='is_customed' value={0}>否</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>经营属性：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.operation : ''}
                  onChange={(e) => this.handelChangeSource(e, 'operation')}
                >
                  <Option key={0} name='operation' value='direct'>经销</Option>
                  <Option key={1} name='operation' value='tp'>代销</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>税率：</span>
                <Input onKeyDown={this.onKeyup} addonAfter='%' placeholder='请输入' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.tax_rate : ''} name='tax_rate' onChange={(e) => this.handleChangeInput(e, 'tax_rate')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>资质控制：</span>
                <Select
                  showSearch
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  disabled={medicalCareOnHtaoData ? (medicalCareOnHtaoData.item_info.charge_level === 'medical') : false}
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.is_qualification : ''}
                  onChange={(e) => this.handelChangeSource(e, 'is_qualification')}
                >
                  <Option key={0} name='is_qualification' value={1}>是</Option>
                  <Option key={1} name='is_qualification' value={0}>否</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>是否海淘：</span>
                <Select
                  showSearch
                  disabled
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  disabled
                  value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.is_cross_border : ''}
                  onChange={(e) => this.handelChangeSource(e, 'is_cross_border')}
                >
                  <Option key={0} name='is_cross_border' value={1}>是</Option>
                  <Option key={1} name='is_cross_border' value={0}>否</Option>
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>有效期：</span>
                <Input onKeyDown={this.onKeyup} addonAfter='年' placeholder='请输入' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.item_useful_life : ''} name='item_useful_life' onChange={(e) => this.handleChangeInput(e, 'item_useful_life')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>包装规格：</span>
                <Input onKeyDown={this.onKeyup} placeholder='请输入' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.packing_specification : ''} name='packing_specification' onChange={(e) => this.handleChangeInput(e, 'packing_specification')} style={{ width: 244, marginRight: '0px' }} />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}></span>重量：</span>
                <Input onKeyDown={this.onKeyup} placeholder='请输入' value={medicalCareOnHtaoData ? medicalCareOnHtaoData.item_info.weight : ''} name='weight' onChange={(e) => this.handleChangeInput(e, 'weight')} style={{ width: 244, marginRight: '4px' }} /> <span>(Kg)</span>
              </section>
            </div>

            <div style={{paddingLeft: '17%', marginTop: '64px', fontSize: '16px', display: medicalCareOnHtaoData ? medicalCareOnHtaoData.extend_propertys.length !== 0 ? 'block' : 'none' : 'none'}}><span className={styles.titles}>扩展信息</span></div>
            <div style={{display: 'flex', flexWrap: 'wrap', width: '100%', position: 'relative', paddingLeft: '13%'}}>
              {medicalCareOnHtaoData ? medicalCareOnHtaoData.extend_propertys || medicalCareOnHtaoData.extend_propertys.length !== 0 ? (
                medicalCareOnHtaoData.extend_propertys.map((item, index) => {
                  if (item.property_type === 'Extend') {
                    return (
                      <section key ={index} className={styles.publicsection}>
                        <span className={styles.publlictitle}><span className={styles.required} style={{display: item.is_required === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                        {item.property_name === '更换周期' ? (
                          <Select
                            showSearch
                            // mode="multiple"
                            onKeyDown={this.onKeyup}
                            style={{ width: 244, marginRight: '0px' }}
                            optionFilterProp="children"
                            placeholder='请选择'
                            value={item.extend_value}
                            onChange={(e) => this.handleChangeSelectExtend(e, index)}
                          >
                            <Option key={0} value=''>请选择</Option>
                            <Option key={1} value='日抛'>日抛</Option>
                            <Option key={2} value='周抛'>周抛</Option>
                            <Option key={3} value='月抛'>月抛</Option>
                            <Option key={4} value='半年抛'>半年抛</Option>
                            <Option key={4} value='年抛'>年抛</Option>
                          </Select>
                        ) : item.property_name === '是否高散光高度数' ? (

                          <Select
                            showSearch
                            // mode="multiple"
                            onKeyDown={this.onKeyup}
                            style={{ width: 244, marginRight: '0px' }}
                            optionFilterProp="children"
                            placeholder='请选择'
                            value={item.extend_value}
                            onChange={(e) => this.handleChangeSelectExtend(e, index)}
                          >
                            <Option key={0} value={null}>请选择</Option>
                            <Option key={1} value={1}>是</Option>
                            <Option key={2} value={0}>否</Option>

                          </Select>
                        ) : item.property_name === 'ContactsType' ? (
                          <Select
                            showSearch
                            // mode="multiple"
                            onKeyDown={this.onKeyup}
                            style={{ width: 244, marginRight: '0px' }}
                            optionFilterProp="children"
                            placeholder='请选择'
                            value={item.extend_value}
                            onChange={(e) => this.handleChangeSelectExtend(e, index)}
                          >
                            <Option key={0} value='普通隐形眼镜'>普通隐形眼镜</Option>
                            <Option key={1} value='彩色隐形眼镜'>彩色隐形眼镜</Option>
                          </Select>
                        ) : item.property_name === '是否支持渐近多焦' ? (
                          <Select
                            showSearch
                            // mode="multiple"
                            onKeyDown={this.onKeyup}
                            style={{ width: 244, marginRight: '0px' }}
                            optionFilterProp="children"
                            placeholder='请选择'
                            value={item.extend_value}
                            onChange={(e) => this.handleChangeSelectExtend(e, index)}
                          >
                            <Option key={0} value={null}>请选择</Option>
                            <Option key={1} value={1}>是</Option>
                            <Option key={2} value={0}>否</Option>
                          </Select>
                        ) : item.property_name === '材质是否支持记忆功能' ? (
                          <Select
                            showSearch
                            // mode="multiple"
                            onKeyDown={this.onKeyup}
                            style={{ width: 244, marginRight: '0px' }}
                            optionFilterProp="children"
                            placeholder='请选择'
                            value={item.extend_value}
                            onChange={(e) => this.handleChangeSelectExtend(e, index)}
                          >
                            <Option key={0} value={null}>请选择</Option>
                            <Option key={1} value={1}>是</Option>
                            <Option key={2} value={0}>否</Option>
                          </Select>
                        ) : item.property_name === '抗UV' ? (
                          <Select
                            showSearch
                            // mode="multiple"
                            onKeyDown={this.onKeyup}
                            style={{ width: 244, marginRight: '0px' }}
                            optionFilterProp="children"
                            placeholder='请选择'
                            value={item.extend_value}
                            onChange={(e) => this.handleChangeSelectExtend(e, index)}
                          >
                            <Option key={0} value={null}>请选择</Option>
                            <Option key={1} value={1}>是</Option>
                            <Option key={2} value={0}>否</Option>
                          </Select>
                        )
                          : (<Input onKeyDown={this.onKeyup} placeholder='请输入' value ={item.extend_value} onChange={(e) => this.handleChangeInputExtend(e, index)} style={{ width: 244, marginRight: '0px' }} />)}

                      </section>
                    )
                  }
                })
              ) : null : null}
            </div>

            <div style={{paddingLeft: '17%', marginTop: '64px', fontSize: '16px', display: medicalCareOnHtaoData ? medicalCareOnHtaoData.sku_propertys.length !== 0 ? 'block' : 'noen' : 'none'}}><span className={styles.titles}>SKU</span></div>
            <div style={{display: 'flex', flexWrap: 'wrap', width: '100%', position: 'relative', paddingLeft: '13%'}}>
              {medicalCareOnHtaoData ? medicalCareOnHtaoData.sku_propertys || medicalCareOnHtaoData.sku_propertys.length !== 0 ? (
                medicalCareOnHtaoData.sku_propertys.map((item, index) => {
                  if (item.property_type === 'SKU') {
                    if (item.property_name !== '光度') {
                      return (
                        <section key ={index} className={styles.publicsection}>
                          <span className={styles.publlictitle}><span className={styles.required} style={{display: item.is_required === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                          <Input
                            onKeyDown={this.onKeyup}
                            placeholder="请输入"
                            value={this.state.skuType === item.property_name ? this.state.skuVal : ''}
                            onChange={(e) =>
                              this.handleChangeInputSku(e, index, item.property_name)
                            }
                            style={{ width: 244, marginRight: '0px', marginBottom: '12px' }}/>
                          <a style={{marginLeft: 4}} onClick={(e) => this.handleSkuAdd(e, index, item.property_name)}>手动添加</a>
                          <div style={{display: 'flex', width: '250px', flexWrap: 'wrap', marginLeft: 136}}>
                            {item.sku_value ? (
                              item.sku_value.length !== 0 ? (
                                item.sku_value.map((item2, index2) => {
                                  return (
                                    <span>
                                      <Popconfirm title="确定要删除吗？" onConfirm={(e) => this.handledelete(e, index, index2)} okText="确定" cancelText="取消">
                                        <a key={index2} style={{marginRight: '8px'}}>{item2}</a>
                                      </Popconfirm>
                                    </span>

                                  )
                                })
                              ) : null
                            ) : null}
                          </div>
                        </section>
                      )
                    } else {
                      return (
                        <section key ={index} className={styles.publicsection}>
                          <span className={styles.publlictitle}><span className={styles.required} style={{display: item.is_required === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                          <Input
                            onKeyDown={this.onKeyup}
                            placeholder="请输入"
                            value={this.state.skuType === item.property_name ? this.state.skuVal : ''}
                            onChange={(e) =>
                              this.handleChangeInputSku(e, index, item.property_name)
                            }
                            style={{ width: 244, marginRight: '0px', marginBottom: '12px' }}/>
                          <a style={{marginLeft: 4}} onClick={(e) => this.handleSkuAdd(e, index, item.property_name)}>手动添加</a>
                          <a style={{marginLeft: 4}} onClick={(e) => this.handleSkuSelectAdd(e, index, item.property_name)}>选择添加</a>
                          <div style={{display: 'flex', width: '250px', flexWrap: 'wrap', marginLeft: 136}}>
                            {item.sku_value ? (
                              item.sku_value.length !== 0 ? (
                                item.sku_value.map((item2, index2) => {
                                  return (
                                    <span>
                                      <Popconfirm title="确定要删除吗？" onConfirm={(e) => this.handledelete(e, index, index2)} okText="确定" cancelText="取消">
                                        <a key={index2} style={{marginRight: '8px'}}>{item2}</a>
                                      </Popconfirm>

                                    </span>
                                  )
                                })
                              ) : null
                            ) : null}
                          </div>
                        </section>
                      )
                    }
                  }
                })
              ) : null : null}
            </div>

            <div style={{width: '100%', marginBottom: '24px', marginTop: '56px', textAlign: 'center'}}>
              <Button type='' shape="round" style={{margin: '0px 8px'}} onClick={this.handleNext}>下一步</Button>
            </div>

            <Modal
              title='选择要添加的SKU属性值'
              visible={this.state.skuVisible}
              onOk={this.handleOk}
              width={700}
              onCancel={this.handleCancel}
              footer={false}
            >
              <div style={{color: '#00f'}}>光度值规则：是否平光(Y/N)-起始度数(1.00)-起跳幅度(0.25)-结束度数(3.00)-二次起幅度(0.50)-二次起跳结束度数(5.00) ...</div>
              <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', margin: '24px 0px'}}>
                <span onClick={(e) => this.handleSkuQuickAdd(e, 'Y-1.00-0.25-6.00-0.50-8.00')} className={styles.skustyle}>Y-1.00-0.25-6.00-0.50-8.00</span>
                <span onClick={(e) => this.handleSkuQuickAdd(e, 'Y-1.00-0.25-6.00-0.50-12.00')} className={styles.skustyle}>Y-1.00-0.25-6.00-0.50-12.00</span>
              </div>
              <div style={{textAlign: 'center'}}>1/1页(共2条记录/每页显示15条)</div>
            </Modal>
          </div>
        </div>
      </div>
    )
  }
}
export default BasicInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addcompleteinformation/medicalequipmentnonhaitao/basic-information.js